import { useEffect, useState } from "react";
import "./UserDefaultAttendanceContent.css";
import images from "../../../../utilities/images/images";
import axios from "axios";
//Redux
import { connect } from "react-redux";
import uiActions from "../../../../redux/ui/action";
import authActions from "../../../../redux/auth/action";
import userPreferenceActions from "../../../../redux/user_preference/action";
import { Link } from "react-router-dom";
import DatePicker from "react-datepicker";
import { PARENT_STUDENT_ATTENDANCE_URL } from "../../../../custom_utilities/baseURL";
import LoaderPopUp from "../../../../components/loader/loader";

const UserDefaultAttendanceContent = (props) => {
  let { startLoading, finishLoading, rollNo,loader } = props;
  const [startDate, setStartDate] = useState(
    new Date(new Date().getTime() - 24 * 60 * 60 * 1000)
  );
  const [endDate, setEndDate] = useState(new Date());

  const [state, setState] = useState({
    attendanceDetails: {},
  });

  useEffect(() => {
    console.log(startDate.toLocaleDateString("en-GB"));
  }, [startDate]);

  useEffect(() => {
    getAttendanceDetails();
  }, []);

  const getAttendanceDetails = async () => {
    const data = {
      method_name: "attendance_report",
      roll_no: `${rollNo}`,
      start_date: `${startDate.toLocaleDateString("en-US")}`,
      end_data: `${endDate.toLocaleDateString("en-US")}`,
    };
    startLoading();
    try {
      const response = await axios.post(PARENT_STUDENT_ATTENDANCE_URL, data);

      console.log("response", response);
      console.log(response.data.data);
      setState((prevState) => ({
        ...prevState,
        attendanceDetails: response.data,
      }));
      finishLoading();
    } catch (error) {
      finishLoading();
      console.log(error);
    }
  };
  return (
    <>
      <div className="container">
        <div className="attendance__content_wrapper">
          <div className="grey_box">
            <div className="bckBtn-title">
              <Link
                className="backBtn"
                to={{
                  pathname: "/user_dashboard",
                }}
              >
                <img src={images.m2_backBtn} alt="backBtn" />
              </Link>
              <h1>Attendance</h1>
            </div>

            <div className="range_div">
              <div className="left">
                <p>Data showing from</p>
                <p>Search by specific date</p>
              </div>
              <div className="right">
                <div className="date">
                  <p>From</p>

                  <DatePicker
                    selected={startDate}
                    onChange={(date) => setStartDate(date)}
                    dateFormat="dd MMM yyyy"
                    maxDate={new Date()}
                  />
                </div>
                <div className="date">
                  <p>To</p>

                  <DatePicker
                    selected={endDate}
                    onChange={(date) => setEndDate(date)}
                    dateFormat="dd MMM yyyy"
                    maxDate={new Date()}
                  />
                </div>
                <button onClick={() => getAttendanceDetails()}>Continue</button>
              </div>
            </div>

            <h2>Overall attendance record</h2>

            <div className="record_cards_wrapper">
              <div className="record_card">
                <p>Total Classes</p>
                <p>{state?.attendanceDetails?.total_working_days}</p>
              </div>
              <div className="record_card">
                <p>Absent</p>
                <p className="red">
                  {state?.attendanceDetails?.total_absent_days}
                </p>
              </div>
              <div className="record_card">
                <p>Present</p>
                <p className="green">
                  {state?.attendanceDetails?.toal_present_days}
                </p>
              </div>
              <div className="record_card">
                <p>Mis punch</p>
                <p className="yellow">
                  {state?.attendanceDetails?.total_miss_punch}
                </p>
              </div>
            </div>
            <h2>Attendance details</h2>
            <div className="details_div">
              <div className="heading">
                <span>Date</span>
                <span>In-Time</span>
                <span>Out-Time</span>
                <span>Status</span>
              </div>
              {state?.attendanceDetails?.data?.map((element) => {
                return (
                  <div className="details">
                    <span>{element.datetime}</span>
                    <span>{element.in_punch_time}</span>
                    <span>{element.out_punch_time}</span>
                    <span>{element.presance_status}</span>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
      {loader && <LoaderPopUp/>}
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    token: state.auth.authToken,
    tokenType: state.auth.authType,
    currentRefundPackage: state.RefundPackageSliceReducer.refundCurrentPackage,
    rollNo: state.auth.user.roll_no,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    startLoading: () => {
      dispatch(uiActions.startLoading());
    },
    finishLoading: () => {
      dispatch(uiActions.finishLoading());
    },
    setUser: (payload) => {
      dispatch(authActions.setUser(payload));
    },
    setUserPreference: (payload) => {
      dispatch(userPreferenceActions.setUserPreference(payload));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UserDefaultAttendanceContent);
